import { countryCodeType } from "../../types";

export const getCountryCode = (countryObject: any) => {
  const countryCodeArray: countryCodeType[] = [];
  for (const key in countryObject) {
    if (countryObject.hasOwnProperty(key)) {
      const values = countryObject[key].split(":");
      countryCodeArray.push({
        code: values[1].trim(),
        name: values[0].trim(),
      });
    }
  }
  countryCodeArray.sort(function (a: any, b: any) {
    return a.code - b.code;
  });
  const countryCode: countryCodeType[] = countryCodeArray.filter(
    (obj, index, self) => index === self.findIndex((o) => o.code === obj.code),
  );
  return countryCode;
};
